<template>
  <!-- 待发货详情页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="订单详情" left-arrow @click-left="$router.back()" />
    </div>
    <div v-if="orderStatusShow" class="orderStatus">
      <img src="../../assets/img/icon/组 6992@2x.png" alt="" />
      <h4>待发货</h4>
    </div>
    <div v-else class="orderStatus">
      <img src="../../assets/img/icon/组 7179@2x.png" alt="" />
      <h4>订单已取消</h4>
    </div>
    <div
      class="Logistics"
      @click="
        $router.push({
          path: '/Logistics',
          query: { orderCode: order_code },
        })
      "
      v-if="contextShow == true"
    >
      <van-steps direction="vertical" :active="0">
        <van-step>
          <p class="LogisticsInfo">{{ context }}</p>
          <van-icon name="arrow" />
          <p class="LogisticsTime">{{ fstime }}</p>
        </van-step>
      </van-steps>
    </div>
    <div
      class="Logistics"
      @click="$toast('暂无最新动态')"
      v-if="contextShow == false"
    >
      <van-steps direction="vertical" :active="0">
        <van-step>
          <p class="LogisticsInfo">{{ titles }}</p>
          <van-icon name="arrow" />
          <p class="LogisticsTime">{{ orderTime }}</p>
        </van-step>
      </van-steps>
    </div>
    <div class="address">
      <div class="mobile">
        <span class="nameLeft">收件人：{{ this.AddressList.consignee }}</span>
        <span class="mobileRight">{{ this.mobile }} </span>
      </div>
      <p>{{ this.AddressList.address_str }}</p>
      <div
        class="modify"
        v-if="this.AddressList.is_update == '0' && this.order_status != 7"
      >
        <van-button
          @click="
            $router.push({
              path: '/orderEditAddress',
              query: { id: addressId },
            })
          "
          >修改</van-button
        >
      </div>
    </div>
    <div class="product">
      <van-card
        v-for="item in productList"
        :key="item.id"
        :num="item.num"
        :price="Number(item.oldPrice).toFixed(2)"
        :desc="item.color_name"
        :title="item.goods_detail_name"
        :thumb="item.color_img"
        @click="toShopping(item.goods_id)"
      >
        <template #num>
          <span>{{ "共" + item.num + "件" }}</span>
        </template>
      </van-card>
      <van-field
        v-if="this.LeavingAMessage != ''"
        v-model="LeavingAMessage"
        rows="2"
        autosize
        label="买家留言"
        type="textarea"
        show-word-limit
        disabled
      />
    </div>
    <div class="preferential">
      <van-cell-group class="info">
        <van-cell title="下单编号" :value="this.order_code" />
        <van-cell title="下单时间" :value="this.time" />
      </van-cell-group>
    </div>
    <div class="productMoney">
      <van-cell
        title="商品金额"
        class="money"
        :value="'￥' + Number(this.money).toFixed(2)"
      />
      <van-cell title="运费" value="￥0" />
      <van-cell title="优惠券" value="暂无可用" />
    </div>
    <div class="btnBox" v-show="btnShow">
      
      <van-button
        @click="toPayMoney()"
        size="small"
        class="evaluate"
        plain
        round
        >取消订单</van-button
      >
      <van-button
      @click="
          $router.push({
            path: '/bill',
            query: { orderCode: $route.query.orderCode },
          })
        "
        color="#999999"
        size="small"
        plain
        round
        >查看发票</van-button
      >
    </div>
    <van-loading
      color="#1989fa"
      size="1rem"
      vertical
      v-show="LoadingShow"
      type="spinner"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      order_status: "",
      context: "",
      fstime: "",
      LeavingAMessage: "",
      contextShow: false,
      LoadingShow: false,
      show: false,
      btnShow: true,
      titles: "您的订单已确认",
      radio: "1",
      messages: "",
      AddressList: {},
      AddressShow: false,
      productList: {},
      order_code: "",
      money: "",
      LogisticsInfo: {},
      time: "",
      mobile: "",
      orderTime: "",
      reg: /^(\d{3})\d{4}(\d{4})$/,
      orderStatusShow: true,
      invoiceStatus:''
    };
  },
  created() {
    this.getAddressList();
    this.getLogistics();
  },
  methods: {
    // 提交退款申请
    async toPayMoney() {
      let orderCode = this.$route.query.orderCode;
      this.LoadingShow = true;
      this.show = true;
      this.$dialog
        .confirm(
          await {
            title: "提示",
            message: "您确定要取消订单吗？",
          }
        )
        .then(() => {
          this.$post({
            url: "/saleService/apply",
            method: "post",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            data: {
              userId: sessionStorage.getItem("EXCLUSIVE"),
              recordCode: orderCode,
              serviceMode: "退款",
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.LoadingShow = false;
                this.show = false;
                this.$toast("提交成功！待商家审核");
                this.$router.back();
              } else {
                this.LoadingShow = false;
                this.show = false;
                this.$toast(res.message);
              }
            })
            .catch((err) => {
              this.LoadingShow = false;
              this.show = false;
              this.$toast(err.message);
            });
        })
        .catch(() => {
          this.LoadingShow = false;
          this.show = false;
          // on cancel
        });
    },
    // 获取地址及商品信息
    async getAddressList() {
      let orderCode = this.$route.query.orderCode;
      this.title = this.$route.query.statusName;
      await this.$post({
        url: "oor/findOrderDetailByOrderCode",
        method: "get",
        params: {
          orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            if (res.data.order_status == 7) {
              this.titles = "您的订单已取消";
              this.orderStatusShow = false;
              this.btnShow = false;
            } else {
              this.orderStatusShow = true;
              this.btnShow = true;
            }
            this.invoiceStatus=res.data.invoiceStatus
            this.LeavingAMessage = res.data.orderDetail[0].remark;
            this.AddressList = res.data.addressInfo;
            this.addressId = res.data.address_id;
            this.mobile = this.AddressList.mobile.replace(
              this.AddressList.mobile.substr(3, 4),
              "****"
            );
            this.order_code = res.data.orderDetail[0].record_code;
            this.money = res.data.accountMoney;
            this.time = res.data.add_time;
            this.productList = res.data.orderDetail;
            this.order_status = res.data.order_status;
          }
        })
        .catch((err) => {
          return;
        });
    },
    toShopping(id) {
      sessionStorage.setItem("P_ID", id);
      this.$router.push("/toShopping");
    },
    // 获取物流信息
    async getLogistics() {
      let orderCode = this.$route.query.orderCode;
      await this.$post({
        url: "/oor/findLOGByCode",
        method: "get",
        params: {
          recordCode: orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.LoadingShow = false;
            if (res.data.data2 !== undefined) {
              let AcceptStation = res.data.data2.reverse();
              this.context = AcceptStation[0].AcceptStation;
              this.fstime = AcceptStation[0].AcceptTime;
              this.contextShow = true;
            } else {
              this.orderTime = res.data.recordTime;
              this.contextShow = false;
            }
          } else {
            this.$toast(res.message);
          }
        })
        .catch((err) => {
          this.$toast("暂无物流信息");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding-bottom: 0.5rem;
  padding-top: 1rem;
  .orderStatus {
    padding: 0.35rem 0.27rem;
    height: 1.5rem;
    background-color: #fff;
    box-sizing: border-box;
    img {
      margin-top: 0.1rem;
      margin-left: 0.2rem;
      width: 1rem;
      height: 1rem;
      float: left;
    }
    h4 {
      float: left;
      line-height: 1rem;
      font-size: 0.4rem;
      font-family: PingFang SC;
    }
  }
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: #ffffff;
    .van-nav-bar {
      background-color: #40000000;
      .van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          margin-top: 0.1rem;
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .Logistics {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    padding: 0.2rem 0 0.2rem 0;
    .van-icon {
      font-size: 0.43rem;
      float: right;
      color: #333;
    }
    .LogisticsInfo {
      width: 7.8rem;
      display: inline-block;
      color: #333;
    }
    .LogisticsTime {
      margin-top: 0.27rem;
      color: #666666;
    }
    .van-steps {
      padding-left: 0.27rem;
      /deep/.van-step__circle-container {
        .van-icon {
          //  position: static;
          display: none !important;
        }
      }
    }
  }
  .address {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    padding-top: 0.53rem;
    .modify {
      width: 100%;
      margin-top: 0.0533rem;
      height: 1rem;
      display: flex;
      align-content: center;
      justify-content: flex-end;
      .van-button {
        padding: 0;
        margin-right: 0.4rem;
        // float: right;
        width: 1.49rem;
        height: 0.72rem;
        color: #333333;
        border: 0.0267rem solid #999999;
        opacity: 1;
        border-radius: 0.3733rem;
      }
    }

    .mobile {
      padding: 0 0.27rem;
      overflow: hidden;
      font-size: 0.4rem;

      .nameLeft {
        float: left;
      }
      .mobileRight {
        position: relative;
        float: right;
        text-align: center;
        vertical-align: middle;
        color: #333333;
        .van-icon {
          top: -0.04rem;
          font-size: 0.4rem;
          vertical-align: middle;
        }
      }
    }
    p {
      padding: 0.48rem 0.27rem 0.2rem 0.27rem;
      font-size: 0.4rem;
      color: #999999;
    }
    .addressInfo {
      padding: 0.3rem 0.27rem;
    }
  }
  .product {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    padding: 0.53rem 0;
    background-color: #fff;
    .van-card {
      background-color: #fff;
      padding: 0;
      .van-card__header {
        .van-card__content {
          margin-left: 0.87rem;
          .van-card__bottom {
            .van-card__price {
              color: #f74b2e;
              font-size: 0.37rem;
            }
            .van-card__num {
              color: #333;
              margin-right: 0.4rem;
            }
          }
          .van-card__title {
            font-size: 0.43rem;
            color: #333333;
            line-height: 1.2rem;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .van-card__desc {
            width: 4.5rem;
            padding-top: 0.2rem;
            color: #666666;
          }
        }
        .van-card__thumb {
          /deep/img {
            margin-left: 0.27rem;
            display: block;
            // width: 2.88rem;
            // height: 2.24rem;
          }
        }
      }
      .van-card__footer {
        margin-top: 0.45rem;
        .van-cell {
          padding: 0;
          /deep/.van-field__label {
            width: 1.8rem;
            text-align-last: left;
          }
        }
      }
    }
    /deep/.van-cell {
      .van-cell__title {
        span {
          font-size: 0.37rem !important;
          color: #333333 !important;
        }
      }
    }
  }
  .preferential {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    border-radius: 0rem;
    .van-cell__value {
      color: #333333;
    }
    .van-cell.van-cell--clickable.van-coupon-cell {
      position: static;
    }
    /deep/[class*="van-hairline"]::after {
      border: 0 solid #ffffff !important;
    }
  }
  .productMoney {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    margin-bottom: 1rem;
    .van-cell__value {
      color: #333333;
    }
    .fare {
      .van-swipe-cell__wrapper {
        .van-cell {
          .van-cell__value {
            color: red;
          }
        }
      }
    }
  }
  .btnBox {
    position: fixed;
    bottom: 0;
    height: 1.2rem;
    width: 100%;
    background-color: #fff;
    .van-button {
      // width: 1.87rem;
      height: 0.72rem;
      // line-height: 0.72rem;
      margin-right: 0.4rem;
      float: right;
      margin-top: 0.2rem;
      font-size: 0.32rem;
      color: #333333 !important;
      border-color: #999999;
    }
    .evaluate {
      border-color: #999999 !important;
      color: #333333 !important;
    }
  }
  .van-loading {
    z-index: 99;
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
